<template>
</template>

<script>
import { getLandingPageSettings } from "@/scripts/settings";

export default {
  name: "ThuliumChat",
  data() {
    return {
      thuliumScriptLoaded: false,
      settings: null
    }
  },
  mounted() {
    window.addEventListener('load', this.addThuliumScript);
    this.fetchSettings();
  },
  beforeDestroy() {
    window.removeEventListener('load', this.addThuliumScript);
  },
  watch: {
    '$i18n.locale': {
      handler: function() {
          this.removeThuliumScript();
          this.addThuliumScript();
      }
    },
    '$i18n.messages': {
      handler: function() {
          this.removeThuliumScript();
          this.addThuliumScript();
      },
      deep: true
    }
  },
  methods: {
    fetchSettings() {
      getLandingPageSettings(this.$route.params.garden).then(settings => {
        this.settings = settings;
        this.addThuliumScript();
      });
    },
    addThuliumScript() {
      if (!this.settings) {
        return;
      }

      const existingScript = document.querySelector('script[src*="thulium.com"]');
      
      const thuliumScript = this.$t('thuliumSettings.script');

      if (!existingScript && 
          this.settings.thuliumSettings && 
          this.settings.thuliumSettings.active && 
          thuliumScript && 
          thuliumScript !== 'thuliumSettings.script') { // Sprawdź czy tłumaczenie istnieje
        
        if (thuliumScript.includes('<script')) {
          const tempEl = document.createElement('div');
          tempEl.innerHTML = thuliumScript;

          const scriptEl = tempEl.querySelector('script');

          if (scriptEl) {
            const newScript = document.createElement('script');

            Array.from(scriptEl.attributes).forEach(attr => {
              newScript.setAttribute(attr.name, attr.value);
            });

            newScript.onload = () => {
              if (!window.ThuliumChat) {
                window.ThuliumChat = {
                  loaded: true,
                  garden: this.$route.params.garden
                };
              }

              if (window.initThuliumChat && typeof window.initThuliumChat === 'function') {
                setTimeout(() => {
                  window.initThuliumChat();
                }, 500);
              }
            };

            document.body.appendChild(newScript);
            this.thuliumScriptLoaded = true;
          } else {
            document.body.insertAdjacentHTML('beforeend', thuliumScript);
            this.thuliumScriptLoaded = true;
          }
        }
      }
    },
    removeThuliumScript() {
      const existingScript = document.querySelector('script[src*="thulium.com"]');
      if (existingScript) {
        existingScript.remove();
      }

      const thuliumSelectors = [
        '.thulium-widget',
        '#thulium-widget',
        '[id^="thulium-"]',
        '[class^="thulium-"]',
        '#thuliumChat',
        '.thuliumChat',
        '[data-thulium]'
      ];

      thuliumSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => element.remove());
      });

      this.thuliumScriptLoaded = false;

      if (window.ThuliumChat) {
        delete window.ThuliumChat;
      }

      for (const key in window) {
        if (key.includes('Thulium') && typeof window[key] !== 'undefined') {
          delete window[key];
        }
      }
    }
  }
}
</script>